import { load, createFragment } from 'utils';
import { lazyImg } from 'lazy-img';
import debounce from 'lodash.debounce';

class LoadMore {
  constructor() {
    this.container = document.querySelector('.js-load-more-container');
    this.nextMarker = document.querySelector('.more-marker');
    this.isLoading = false;
    if (!this.nextMarker || !this.container) {
      return;
    }
    this.getLoadMorePosition();
    this.addEventListeners();
  }

  /**
   * tests for passive event listener support
   */
  testPassive() {
    this.supportsPassive = false;
    try {
      const opts = Object.defineProperty({}, 'passive', {
        get: () => (this.supportsPassive = true),
      });
      window.addEventListener('test', null, opts);
    } catch (e) {
      /**/
    }
  }

  addEventListeners() {
    window.addEventListener('resize', this.onResize);
    window.addEventListener(
      'scroll',
      this.onScroll,
      this.supportsPassive ? { passive: true } : false,
    );
  }

  getLoadMorePosition() {
    if (!this.nextMarker) {
      return;
    }
    this.morePos = this.nextMarker.offsetTop;
  }

  onResize = debounce(this.getLoadMorePosition, 400);

  onScroll = () => {
    if (this.isLoading || !this.nextMarker) {
      return;
    }

    if (window.scrollY + window.innerHeight / 2 < this.morePos) {
      return;
    }

    this.loadNext(this.nextMarker.dataset.url).then(() => {
      this.isLoading = false;
      if (!this.nextMarker) {
        window.removeEventListener('scroll', this.onScroll);
      }
    });
  };

  async loadNext(url) {
    this.isLoading = true;
    const response = await load(url);
    const html = createFragment(response);
    this.container.replaceChild(html, this.nextMarker);
    this.nextMarker = document.querySelector('.more-marker');
    lazyImg.getImages();
    this.getLoadMorePosition();
  }
}

export const loadMore = new LoadMore();



// WEBPACK FOOTER //
// ./src/js/load-more.js